export default __webpack_public_path__ + "static/media/2_2.50395504.jpg";